<template>
  <div>
    <modal-form modal-id="add-link-order" animation="fadeInRight" v-if="loaded">
      <div slot="title">Save Link Order</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="formData['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Client</div>
            <div class="col-lg-9">
              <v-select :options="this.f.clients" v-model="formData['client']" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Group</div>
            <div class="col-lg-9">
              <v-select
                :options="this.f.groups"
                label="name"
                index="id"
                v-model="formData['group']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Categories:</div>
            <div class="col-lg-9">
              <v-select
                :options="this.f.categories"
                v-model="formData['categories']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Build Order</div>
            <div class="col-lg-9">
              <v-select
                :options="[{id: null, name: '>>>'}].concat(this.f.orders)"
                label="name"
                index="id"
                v-model="formData['buildOrder']"
                @input="updateOrderCount"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Number</div>
            <div class="col-lg-9">
              <input type="number" min="1" class="form-control" v-model.number="formData['number']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Language</div>
            <div class="col-lg-9">
              <v-select :options="langs" v-model="formData['language']" index="index" label="label"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Backup Language</div>
            <div class="col-lg-9">
              <v-select :options="langs" v-model="formData['backupLang']" index="index" label="label"></v-select>
            </div>
          </div>
          <div class="row m-b-md">
            <div class="col-lg-12">
              <div class="m-b-md" >Targets</div>
              <vue-excel-editor
                v-model="targets"
                no-footer
                new-if-bottom
                class="pull-right"
                free-select
                allow-add-col
              >
                <vue-excel-column mandatory="true" field="url" label="Url" text-transform="lowercase"></vue-excel-column>
                <vue-excel-column mandatory="true" field="anchor" label="Anchor"></vue-excel-column>
                <vue-excel-column field="domain" label="Domain"></vue-excel-column>
              </vue-excel-editor>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Source Clients</div>
            <div class="col-lg-9">
              <v-select :options="this.f.clients" multiple v-model="formData['source']['clients']" label="name" @input="clients"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Source Groups</div>
            <div class="col-lg-9">
              <v-select
                multiple
                :options="this.f.groups"
                label="name"
                v-model="formData['source']['groups']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Deadline</div>
            <div class="col-lg-9">
              <input type="date" class="form-control" v-model="formData['deadline']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Description</div>
            <div class="col-lg-9">
              <textarea class="form-control" rows="10" v-model="formData['description']"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveOrder">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
  </div>
</template>
<script>
import Modal from '../../../../Helpers/Modal/Form'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { LINK_ORDER_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      targets: [],
      loaded: false,
      formData: {}
    }
  },
  props: ['addOrder'],
  components: {
    modalForm: Modal
  },
  mounted () {
    this.loaded = true
    this.formData = JSON.parse(JSON.stringify(this.addOrder))
    if (!this.formData.source.clients) {
      this.formData.source.clients = []
    }

    if (!this.langs.length) {
      this.$store.dispatch('loadLanguages')
    }

    if (!this.formData.source.groups) {
      this.formData.source.groups = []
    }

    this.formData.targets.forEach(row => {
      this.targets.push({
        url: row.url,
        anchor: row.anchor,
        domain: row.targetDomain
      })
    })
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      order: 'getLinkOrder',
      langs: 'getLanguages'
    })
  },
  methods: {
    clients (c) {
      console.log(c)
    },
    saveOrder () {
      this.formData.targets = []
      this.targets.forEach(row => {
        if (row.url && row.anchor) {
          this.formData.targets.push({
            url: row.url,
            anchor: row.anchor,
            number: row.number,
            targetDomain: row.domain
          })
        }
      })

      if (this.formData.targets.length < 1) {
        this.$toastr.error('Please add targets to the order', 'Targets missing')
        return
      }

      if (!this.formData.name || !this.formData.client || !this.formData.number || !this.formData.targets) {
        this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
        return
      }

      if (!this.formData.source.groups) {
        this.formData.source.groups = []
      }
      if (!this.formData.source.clients) {
        this.formData.source.clients = []
      }
      let saveOrder = {
        number: this.formData.number,
        targets: this.formData.targets,
        source: {
          clients: this.formData.source.clients.map(c => c.id),
          groups: this.formData.source.groups.map(c => c.id)
        },
        deadline: this.formData.deadline,
        description: this.formData.description,
        language: this.formData.language,
        backupLang: this.formData.backupLang,
        categories: this.formData.categories
      }

      axios.patch(`/pbn/links/order/${this.order.id}`, saveOrder)
        .then(r => {
          this.$store.commit(LINK_ORDER_SET, r.data.order)
          $('#add-link-order').modal('hide')
          this.$toastr.success('Order added successfully', 'Brilliant stuff lad')
        })
        .catch(e => {
          this.$toastr.error(e, 'Not so great, is it...')
        })
    },
    updateOrderCount (id) {
      this.f.orders.forEach(o => {
        if (o.id === id) {
          this.formData.number = o.size
          return true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order/OrderModal.vue